import React, { Fragment, useRef, useEffect } from "react";

import isMobile from "common/helpers/isMobile";
import { t } from 'translates';

import MultipleSelect from "./components/MultipleSelect";
import Dates from "./components/Dates";
import ToggleButton from "./components/ToggleButton";
import SessionsNewFilterContainer from "./containers/SessionsNewFilterContainer";
import classNames from "classnames";

function SessionsNewFilter({ children, type }) {

  const parrentCategory = useRef(null);

  return (
    <SessionsNewFilterContainer type={type}>
      {({filter,
        filterCurrent,
        parentCategoryChange,
        toggleFilter,
        dateChange,
        selectChange,
        toggleChange,
        isFilterOpen,
        isFilterTouched,
        resetFilters,
        submit,
        filtersCount}) => (
          <Fragment>
            <div className={classNames(`sessions-new-filter`, {
              "sessions-new-filter--open": isFilterOpen,
            })}
            style={{top: 70 - (parrentCategory && parrentCategory.current && parrentCategory.current.offsetHeight)}}
            >
              {filter.parent_category && (
                <div className="sessions-new-filter__parent-category" ref={parrentCategory} >
                  <div className="sessions-new-filter__parent-category-scroll" >
                    {filter.parent_category.map((item) => (
                      <a
                        className={classNames(`sessions-new-filter__parent-category-item`, {
                          "is-active": filterCurrent.parent_category === item.value,
                        })}
                        key={item.value}
                        href="#"
                        onClick={(e) => {
                          e.preventDefault;
                          parentCategoryChange(item.value, item.original_name);
                        }}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
              <div className="session-new-filter__sticky">
                {isMobile && (
                  <button
                    className="sessions-new-filter__filter-trigger"
                    onClick={() => toggleFilter()}
                  >
                    {t('Filters', DT_SESSIONSNEW)}
                    {filtersCount() > 0 && (
                      <span>{filtersCount()}</span>
                    )}
                  </button>
                )}

                <div className={classNames(`sessions-new-filter__body`, {
                  "sessions-new-filter__body--mobile": isMobile,
                  "is-active": isFilterOpen,
                })}
                >
                  {isMobile && (
                    <div className="sessions-new-filter__body-header">
                      <button
                        className="sessions-new-filter__filter-close"
                        onClick={() => toggleFilter()}
                      />
                      <span className="sessions-new-filter__title">
                        {t('Filters', DT_SESSIONSNEW)}
                      </span>
                      <button
                        className="sessions-new-filter__reset-mobile"
                        onClick={() => resetFilters()}
                      >
                        {t('Clear all', DT_SESSIONSNEW)}
                      </button>
                    </div>
                  )}
                  <div className="sessions-new-filter__body-inner">
                    {filter.date && (
                      <Dates
                        {...filter.date}
                        change={dateChange}
                        start_date={
                          filterCurrent.start_date
                            ? new Date(filterCurrent.start_date)
                            : filterCurrent.start_date
                        }
                        end_date={
                          filterCurrent.end_date
                            ? new Date(filterCurrent.end_date)
                            : filterCurrent.end_date
                        }
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filter.language && (
                      <MultipleSelect
                        label="Language"
                        name="language"
                        filterCurrent={filterCurrent.language}
                        options={filter.language}
                        change={selectChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filter.language && (
                      <MultipleSelect
                        label="Duration"
                        name="duration"
                        filterCurrent={filterCurrent.duration}
                        options={filter.duration}
                        change={selectChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filter.category && filter.category.length > 0 && (
                      <MultipleSelect
                        label="Category"
                        name="category"
                        filterCurrent={filterCurrent.category}
                        options={filter.category}
                        change={selectChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filter.price && (
                      <MultipleSelect
                        label='Price'
                        name="price"
                        filterCurrent={filterCurrent.price}
                        options={filter.price}
                        change={selectChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filter.discovery_series && (
                      <ToggleButton
                        label='Discovery series'
                        name="discovery_series"
                        filterCurrent={filterCurrent.discovery_series}
                        defaultValue={filter.discovery_series.value}
                        change={toggleChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filter.product_cycles && (
                      <ToggleButton
                        label='Course cycle'
                        name="product_cycles"
                        filterCurrent={filterCurrent.product_cycles}
                        defaultValue={filter.product_cycles.value}
                        change={toggleChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}


                    {filter.online_talks && (
                      <ToggleButton
                        label='Online talks'
                        name="online_talks"
                        filterCurrent={filterCurrent.online_talks}
                        defaultValue={filter.online_talks.value}
                        change={toggleChange}
                        filterOpen={isFilterTouched} // @todo: rename
                      />
                    )}

                    {filtersCount() > 0 && !isMobile && (
                      <button
                        className="sessions-new-filter__reset"
                        onClick={() => resetFilters()}
                      >
                        {t('Clear all', DT_SESSIONSNEW)}
                      </button>
                    )}

                    {filter.hide_full_sessions && (
                      <ToggleButton
                        label='Hide full sessions'
                        name={"hide_full_sessions"}
                        filterCurrent={filterCurrent.hide_full_sessions}
                        defaultValue={filter.hide_full_sessions.value}
                        change={toggleChange}
                        filterOpen={isFilterTouched} // @todo: rename
                        type={"radio"}
                      />
                    )}

                    {filter.hide_full_conferences && (
                      <ToggleButton
                        label='Hide full conferences'
                        name={"hide_full_conferences"}
                        filterCurrent={filterCurrent.hide_full_conferences}
                        defaultValue={filter.hide_full_conferences.value}
                        change={toggleChange}
                        filterOpen={isFilterTouched} // @todo: rename
                        type={"radio"}
                      />
                    )}
                  </div>

                  {isMobile && (
                    <button
                      className="sessions-new-filter__submit"
                      onClick={() => submit()}
                    >
                      {t('Apply', DT_SESSIONSNEW)}
                    </button>
                  )}
                </div>

                {filter.link && (
                  <a
                    className={classNames(`sessions-new-filter__change-view`, {
                      "sessions-new-filter__change-view--calendar": type === "calendar",
                      "sessions-new-filter__change-view--list": type === "list",
                    })}
                    href={filter.link.url}
                    onClick={() => {
                      window.dataLayer && window.dataLayer.push({
                        'event': type === "list" ? 'calendarView' : 'listView'
                      });
                    }}
                  >
                    {filter.link.name}
                  </a>
                )}
              </div>
            </div>
            {children({ isFilterOpen })}
          </Fragment>
      )}
    </SessionsNewFilterContainer>

  );
}

export default SessionsNewFilter;
